import { render } from "./DirectionHero.vue?vue&type=template&id=4686923b&scoped=true"
import script from "./DirectionHero.vue?vue&type=script&lang=js"
export * from "./DirectionHero.vue?vue&type=script&lang=js"

import "./DirectionHero.vue?vue&type=style&index=0&id=4686923b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4686923b"]])

export default __exports__